import { render, staticRenderFns } from "./services-install-script.vue?vue&type=template&id=4ed8dccc&scoped=true&"
import script from "./services-install-script.vue?vue&type=script&lang=js&"
export * from "./services-install-script.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8dccc",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-install-script.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/confirmations?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-install-script.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports